"use client";

import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import "./Home/Home.css";

import { fragenHome } from "./Home/data";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";

import { TopSection } from "./Home/homeSections/TopSection";
import { ReadySetSold } from "@/app/Home/homeSections/ReadySetSold";


const MoreMoneyStorys = dynamic(
  () =>
    import("@/app/Home/homeSections/MoreMoneyStorys").then(
      (m) => m.MoreMoneyStorys
    ),
  { ssr: false }
);

const SellYourCarBanner = dynamic(
  () =>
    import("@/app/Home/homeSections/SellYourCarBanner").then(
      (m) => m.SellYourCarBanner
    ),
  { ssr: false }
);

const AutoKarousell = dynamic(
  () =>
    import("@/app/Home/homeSections/AutoKarousell").then(
      (m) => m.AutoKarousell
    ),
  { ssr: false }
);

const TrustPilotSection = dynamic(
  () => import("@/app/Home/homeSections/TrustPilotSection"),
  { ssr: false }
);

const IntresstedInMore = dynamic(
  () => import("@/common/IntrestedInMore").then((m) => m.IntresstedInMore),
  { ssr: false }
);

const HäufigeFragen = dynamic(
  () => import("@/common/HäufigeFragen").then((m) => m.HäufigeFragen),
  { ssr: false }
);

const Ratgeber = dynamic(() => import("@/components/Ratgeber/Ratgeber"), {
  ssr: false,
});

const Banner = dynamic(() => import("@/common/Banner").then((m) => m.Banner), {
  ssr: false,
});

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function HomePage({ initialCarData = null }) {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const [showDeferredSections, setShowDeferredSections] = useState(false);
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (step === 12) {
      setShowDeferredSections(false);
      return;
    }

    let revealed = false;
    const reveal = () => {
      if (revealed) return;
      revealed = true;
      setShowDeferredSections(true);
    };

    const events = ["pointerdown", "keydown", "touchstart", "scroll"];
    const options = { passive: true };
    events.forEach((event) => window.addEventListener(event, reveal, options));

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, reveal, options)
      );
    };
  }, [step]);


  return (
    <>
      <div className="home-container">
        <TopSection
          initialCarData={initialCarData}
          step={step}
          setStep={setStep}
          selectedBrand={selectedBrand}
          setSelectedBrand={setSelectedBrand}
          selectedModel={selectedModel}
          setSelectedModel={setSelectedModel}
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          selectedBauform={selectedBauform}
          setSelectedBauform={setSelectedBauform}
          selectedFuel={selectedFuel}
          setSelectedFuel={setSelectedFuel}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          selectedPs={selectedPs}
          setSelectedPs={setSelectedPs}
          selectedTransmission={selectedTransmission}
          setSelectedTransmission={setSelectedTransmission}
          selectedDoors={selectedDoors}
          setSelectedDoors={setSelectedDoors}
          setSelectedModelType={setSelectedModelType}
          selectedModelType={selectedModelType}
          selectedKmStand={selectedKmStand}
          setSelectedKmStand={setSelectedKmStand}
        />

        {step === 12 && (
          <>
            <AnmeldenSection
              title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
              fin={null}
              isManual={isSecondaryMethod}
              marke={selectedBrand}
              model={selectedModel}
              baujahr={selectedYear}
              bodytype={selectedBauform}
              fueltype={selectedFuel}
              variant={selectedVariant}
              ps={selectedPs}
              gearbox={selectedTransmission}
              doors={selectedDoors}
              modelType={selectedModelType}
              kmStand={selectedKmStand}
              page="Homepage"
            />
            <Banner removeContent className="Banner-anmelden" />
          </>
        )}

        {step !== 12 && (
          <>
            <ReadySetSold />
            {showDeferredSections && (
              <>
                <MoreMoneyStorys />
                <SellYourCarBanner />
                <AutoKarousell />
                <TrustPilotSection />
                <IntresstedInMore
                  title="Interessiert an mehr?"
                  titleOne="Autoverkauf zum Bestpreis"
                  linkTextOne="Auto Verkaufen"
                  titleTwo="Verfolge den Wert deines Autos"
                  linkTextTwo="Auto bewerten"
                  titleThree="So Funktioniert's"
                  linkTextThree="Mehr erfahren"
                  linkone="/auto-verkaufen"
                  linktwo="/auto-bewerten"
                  linkthree="/so-funktionierts"
                />
                <HäufigeFragen
                  fragen={fragenHome}
                  image={FAQImage}
                  title="Häufig gestellte Fragen zu Autoeinfachlos"
                />
                <Ratgeber
                  title="Weitere hilfreiche Informationen"
                  wasistmeinautowert
                  fahrgestellnummerPruefen
                  listenpreisBerechnen
                  wirkaufendeinautoAlternative
                />

                <Banner />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default HomePage;
